module.exports = __webpack_public_path__ + "static/bannersvg-549b667cac3ed8e5ba00bc23368d9210.svg";